import { z } from 'zod';
import { baseAreaSchema } from './IBaseArea';
import { configFloorSchema } from './IConfigFloor';

// Schemas (source of truth)
export const areaViewSchema = z.object({ ...baseAreaSchema.shape, ...configFloorSchema.shape }).extend({
	tagIds: z.array(z.string()),
});

// Types (derived from schemas)
export type IAreaView = z.infer<typeof areaViewSchema>;
